import React from 'react';
import {
  Dialog,
  Button,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

import { getISODateTimeString } from '../../../utils/dateUtils';

const DateTimeModal: React.FC<{
  dateTime: string | null;
  setDateTime(value: string | null): void;
}> = ({ dateTime, setDateTime }) => {
  return dateTime ? (
    <Dialog open={!!dateTime}>
      <DialogTitle id="form-dialog-title">Date</DialogTitle>
      <DialogContent dividers>
        <Typography variant="caption" color="textSecondary">
          Token
        </Typography>
        <Typography gutterBottom>{getISODateTimeString(dateTime)}</Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            setDateTime(null);
          }}
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};

export default DateTimeModal;
